import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, CreditCard } from "lucide-react";

export default function FinancingBand() {
    return (
        <section
            className="relative overflow-hidden bg-cream py-16 sm:py-20 text-ink"
            data-testid="home-financing-band"
        >
            <div className="mx-auto max-w-6xl px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                    className="flex flex-col items-start justify-between gap-8 rounded-3xl border border-gold/25 bg-white/60 p-8 backdrop-blur sm:flex-row sm:items-center sm:p-12"
                >
                    <div className="max-w-2xl">
                        <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-gold-dark">
                            <CreditCard size={15} />
                            Flexible Monthly Payment Plans
                        </div>
                        <h2 className="mt-4 font-serif text-3xl leading-[1.1] sm:text-4xl">
                            Treat now,{" "}
                            <span className="italic text-gold-dark">pay over time.</span>
                        </h2>
                        <p className="mt-4 text-ink/60 sm:text-lg">
                            Pre-qualify in seconds with Cherry — no hard credit check,
                            0% APR options available. Plan the treatments you love on a
                            schedule that works for you.
                        </p>
                    </div>

                    <Link
                        to="/book"
                        data-testid="home-financing-cta"
                        className="group inline-flex shrink-0 items-center gap-2 rounded-full bg-ink px-7 py-4 text-sm font-semibold uppercase tracking-[0.15em] text-cream transition-all duration-300 hover:bg-gold-dark hover:shadow-[0_0_30px_-6px_rgba(140,114,38,0.7)]"
                    >
                        See Payment Options
                        <ArrowRight
                            size={16}
                            className="transition-transform duration-300 group-hover:translate-x-1"
                        />
                    </Link>
                </motion.div>
            </div>
        </section>
    );
}
